














































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import Env from '@finx/web-repository/src/services/Env'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import BackofficeNavigationStore from '@/components/Backoffice/NavBar/Store/BackofficeNavigationStore'

@Component

export default class ComponentBackofficeTopNavBar extends Vue {
  mdAjuda: boolean = false

  get modalAjuda() { return this.mdAjuda }
  set modalAjuda(value: boolean) { this.mdAjuda = value }

  get getBackofficeNavigationStore() {
    return getModule(BackofficeNavigationStore, this.$store)
  }

  get drawer() {
    return !!this.getBackofficeNavigationStore.navigationDrawer
  }

  set drawer(value: boolean) {
    this.getBackofficeNavigationStore.setNavigationDrawer(value)
  }

  get miniSync() {
    return !!this.getBackofficeNavigationStore.miniSync
  }

  set miniSync(value: boolean) {
    this.getBackofficeNavigationStore.setMiniSync(value)
    localStorage.setItem('miniSync', String(this.getBackofficeNavigationStore.miniSync))
  }

  trocarSenha(): void {
    this.$ga.event('autenticacao', 'alterar-senha', this.$user.profile.email)
    window.location.href = `${Env.API_FINX_AUTH}ChangePassword`
  }

  async logout() {
    await Auth.logout()
  }

  goTo(rota: string) {
    this.$router.push(rota)
  }

  redirectoToDocumentsPage() {
    this.$router.push({ name: 'hospital-profile-documents' })
  }

  setMiniSync() {
    if (localStorage.getItem('miniSync') === null) localStorage.setItem('miniSync', String(false))
    this.getBackofficeNavigationStore.setMiniSync(localStorage.getItem('miniSync') === 'true')
  }

  created() {
    window.addEventListener('keydown', this.keyboardShortCuts)
    this.$nextTick(() => {
      window.addEventListener('resize', this.setMiniSync)
      this.setMiniSync()
    })
  }

  destroyed() {
    window.removeEventListener('resize', this.setMiniSync)
    window.removeEventListener('keydown', this.keyboardShortCuts)
  }

  keyboardShortCuts(event: KeyboardEvent) {
    if (event.altKey && event.code === 'Escape') this.miniSync = !this.miniSync
  }
}
